import { Link } from 'react-router';
import { Card } from '../components/ui';

export function Denied({ notFound }: { notFound?: boolean }) {
    return (
        <Card>
            <h1 className="text-base font-semibold text-slate-800">
                {notFound ? 'That page does not exist' : 'You do not have access to this'}
            </h1>
            <p className="mt-2 text-sm text-slate-600">
                {notFound
                    ? 'The link may be out of date.'
                    : 'Your account does not have permission for this screen. '
                      + 'Ask an administrator if you think it should.'}
            </p>
            <Link to="/" className="mt-4 inline-block text-sm text-[var(--brand-primary)] hover:underline">
                Back to the dashboard
            </Link>
        </Card>
    );
}
